import { Route } from "react-router-dom";
import SignUp from "../pages/Authentication/SignUp";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ComingSoon from "../pages/Authentication/ComingSoon";
import UnderMaintenance from "../pages/Authentication/UnderMaintenance";

/**
 * 📌 Rutas de plantillas de autenticación
 *
 * Estas son vistas de ejemplo o páginas temporales
 * (usadas solo como demostraciones o componentes visuales)
 */
const authTemplatesRoutes = (
  <>
    <Route path="/auth/signup" element={<SignUp />} />
    <Route path="/auth/reset-password" element={<ResetPassword />} />
    <Route path="/auth/coming-soon" element={<ComingSoon />} />
    <Route path="/auth/under-maintenance" element={<UnderMaintenance />} />
  </>
);

export default authTemplatesRoutes;
